require('./bootstrap');
require('./datatables');

const { io } = require('socket.io-client');
window.io = io;
window.populate = require('populate.js');
window.moment = require('moment');
window.moment.locale('pt-br');

window.changeTVMode = (mode = null) => {
    if (
        location.pathname.includes("new-screen") ||
        location.pathname.includes("task_manager") ||
        location.pathname.includes("ticket_history")
    ) {
        $('#page-container').attr('class', 'container');
        $('#page-title').attr('hidden', false);
        setCookie("realtimeSettings", "mini", "tvMode");
    };

    if (!mode) {
        $('#page-container').toggleClass('container container-fluid pt-3')
        $('#page-title').attr('hidden', function (index, attr) {
            return attr == 'hidden' ? false : true;
        });
        $.fn.dataTable.tables({ visible: true, api: true }).columns.adjust();
        setCookie("realtimeSettings", "full", "tvMode");
        return true;
    }

    if (mode == "full") {
        $('#page-container').attr('class', 'container-fluid pt-3');
        $('#page-title').attr('hidden', true);
        setCookie("realtimeSettings", "full", "tvMode");
    } else {
        $('#page-container').attr('class', 'container');
        $('#page-title').attr('hidden', false);
        setCookie("realtimeSettings", "mini", "tvMode");
    }

    $.fn.dataTable.tables({ visible: true, api: true }).columns.adjust();
}

window.getCookie = (name, field = null) => {
    try {
        const value = `; ${document.cookie}`;
        if (!value) return false;
        const parts = value.split(`; ${name}=`);
        const cookieString = (parts.length === 2) ? parts.pop().split(';').shift() : null;
        if (!cookieString) return false;
        const cookieJson = JSON.parse(cookieString);
        if (!field) return cookieJson;
        return cookieJson[field] ? cookieJson[field] : false;
    } catch {
        return false;
    }
}

window.setCookie = (name, value, field = null) => {
    if (!name) return false;
    if (value == null || value == undefined) return false;

    try {
        if (!field) {
            document.cookie = `${name}=${value};path=/`;
            return true;
        }

        const foundCookie = getCookie(name);
        if (!foundCookie) return false;
        foundCookie[field] = value;
        document.cookie = `${name}=${JSON.stringify(foundCookie)};path=/`;
        return true;
    } catch {
        return false;
    }
}

window.deleteCookie = (name, field = null) => {
    if (!name) return false;

    try {
        if (!field) {
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
            return true;
        }

        const foundCookie = getCookie(name);
        if (!foundCookie || !foundCookie[field]) return false;
        delete foundCookie[field];
        document.cookie = `${name}=${JSON.stringify(foundCookie)};path=/`;
        return true;
    } catch {
        return false;
    }
}

import 'jquery-ui/ui/widgets/tabs';
import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/ui/widgets/droppable';
import 'jquery-ui/ui/widgets/resizable';
import 'jquery-ui/ui/widgets/button';
import 'jquery-ui/ui/widgets/autocomplete';

window.Vue = require('vue');
import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, {
    hideModules: { 'image': true, 'code': true },
    image: {},
    maxHeight: "500px",
});

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

import VueApexCharts from 'vue-apexcharts';
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);

import vSelect from 'vue-select';
Vue.component('v-select', vSelect);

import Swal from 'sweetalert2'
import vueWysiwyg from 'vue-wysiwyg';
window.Swal = require('sweetalert2');

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

Vue.component("Multiselect", Multiselect);

import store from './store/index';

Vue.component('contacts', require('./components/newScreen/contacts/contacts.vue').default);

Vue.component('loading-indicator-component', require('./components/LoadingIndicatorComponent.vue').default);
Vue.component('home-component', require('./components/HomeComponent.vue').default);

// alerts
Vue.component('inline-alert-component', require('./components/alerts/InLine.vue').default);

// users box
Vue.component('default-user-box-component', require('./components/boxes/DefaultUserBox.vue').default);
Vue.component('user-realtime-box-component', require('./components/boxes/UserRealtimeBox.vue').default);
Vue.component('users-box-component', require('./components/boxes/Users.vue').default);
Vue.component('users2-box-component', require('./components/boxes/Users2.vue').default);

// inputs
Vue.component('start-end-date-component', require('./components/filters/StartEndDate.vue').default);
Vue.component('input-component', require('./components/filters/DefaultInput.vue').default);
Vue.component('multiselect-component', require('./components/filters/MultiSelect.vue').default);
Vue.component('group-extension-component', require('./components/filters/GroupExtension.vue').default);
Vue.component('select-component', require('./components/filters/DefaultSelect.vue').default);
Vue.component('texteditor-component', require('./components/Wysiwyg.vue').default);
Vue.component('textarea-component', require('./components/filters/Textarea.vue').default);
Vue.component('costumers-select-component', require('./components/filters/CostumerSelect.vue').default);
Vue.component('users-component', require('./components/users/UsersComponent').default);
Vue.component('multiselect-chat', require('./components/filters/MultiselectChat').default);

// charts
Vue.component('chart-donut-satisfaction-component', require('./components/charts/DonutSatisfactionComponent.vue').default);
Vue.component('chart-bar-component', require('./components/charts/BarComponent.vue').default);
Vue.component('chart-multibar-component', require('./components/charts/MultiBarComponent.vue').default);
Vue.component('chart-donut-component', require('./components/charts/DonutComponent.vue').default);

// modals
Vue.component('modal-component', require('./components/modals/ModalComponent.vue').default);

//new screen menus
Vue.component('menu-esquerdo', require('./components/newScreen/MenuEsquerdo.vue').default);
Vue.component('barra-direito', require('./components/newScreen/BarraDireito.vue').default)

//escrever aguma coisa depois
Vue.component('ponta-de-lanca', require('./components/newScreen/PontaDeLanca.vue').default);
Vue.component('select-product', require('./components/newScreen/SelectProduct.vue').default)
Vue.component('button-push', require('./components/newScreen/ButtonPush.vue').default)

//redes sociais
Vue.component('redes-sociais', require('./components/newScreen/redesSociais/TodasRedesSociais.vue').default);

//modals new screen
Vue.component('modal-discar', require('./components/newScreen/modals/ModalDiscar.vue').default)
Vue.component('modal-agendamento', require('./components/newScreen/modals/ModalAgendamento.vue').default)
Vue.component('modal-pause', require('./components/newScreen/modals/ModalPause.vue').default)

//ocorrencias
Vue.component('todas-ocorrencias', require('./components/newScreen/ocorrencias/TodasOcorrencias.vue').default)
Vue.component('nova-ocorrencia', require('./components/newScreen/ocorrencias/NovaOcorrencia.vue').default)
Vue.component('historicos', require('./components/newScreen/ocorrencias/Historico.vue').default);
Vue.component('tableHistory', require('./components/newScreen/ocorrencias/tableHistory.vue').default);
Vue.component('logModal', require('./components/newScreen/ocorrencias/logModal.vue').default);
Vue.component('infoModal', require('./components/newScreen/ocorrencias/infoModal.vue').default);

// components Realtime
Vue.component('realtime-app', require('./components/realtime/RealtimeApp').default);
Vue.component('card-status', require('./components/realtime/CardStatus.vue').default);

Vue.component('marketing-messages-component', require('./components/marketing/ViewMessages.vue').default);
Vue.component('marketing-index', require('./components/marketing/MarketingIndex.vue').default);
Vue.component('marketing-auster', require('./components/marketing/MarketingAuster.vue').default);

Vue.component('status-campanhas', require('./components/marketing/StatusCampanhas.vue').default);
Vue.component('catalogo-produtos', require('./components/catalogo/CatalogoProdutos.vue').default);
Vue.component('catalogo-arquivos', require('./components/catalogo/CatalogoArquivos.vue').default);
Vue.component('catalogo-index', require('./components/catalogo/CatalogoIndex.vue').default);

Vue.component('costumers-index', require('./components/costumers/CostumersIndex.vue').default)

Vue.component('history', require('./components/history/History.vue').default);

Vue.component('solicitation', require('./components/solicitation/solicitation.vue').default);

Vue.component('dt-pedidos', require('./components/solicitation/DtPedidos.vue').default);
Vue.component('dtModalPedidos', require('./components/solicitation/modalPedidos.vue').default);

Vue.component('dt-tecnicas', require('./components/solicitation/DtTecnicas.vue').default);
Vue.component('dtModalTecnicas', require('./components/solicitation/modalTecnicas.vue').default);

Vue.component('dt-solicitacoes', require('./components/solicitation/DtSolicitacoes.vue').default);
Vue.component('details-modal', require('./components/solicitation/RequestDetailsModal.vue').default);

Vue.component('feedbackModal', require('./components/solicitation/feedbackModal.vue').default);
Vue.component('noteModal', require('./components/solicitation/NoteModal.vue').default);

Vue.component('dtModalUsers', require('./components/realtime/components/modalUsers.vue').default);
Vue.component('dtModalVisualizar', require('./components/realtime/components/modalVisualizar.vue').default);
Vue.component('dtModalVisualizarUra', require('./components/realtime/components/modalVisualizarUra.vue').default);
Vue.component('dtModalVisualizarFila', require('./components/realtime/components/modalVisualizarFila.vue').default);

Vue.component('tickets-manager', require('./components/tickets/manager/TicketsManager.vue').default);
Vue.component('tickets-page', require('./components/tickets/TicketsPage.vue').default);
// Vue.component('ticketModal', require('./components/tickets/TicketDetailsModal.vue').default);

Vue.component('tasks-page', require('./components/tasks/TasksPage.vue').default);
Vue.component('tasks-manager', require('./components/tasks/TasksManager.vue').default);
Vue.component('task-manager-widget', require('./components/tasks/TaskManagerWidget.vue').default);

// Settings

Vue.component('settings', require('./components/settings/Settings.vue').default);

Vue.component('my-account', require('./components/users/MyAccount.vue').default);

// Instância Vue principal para elementos gerais (se necessário)
if (document.getElementById('app')) {
    new Vue({
        el: '#app',
        store,
        // Outros parâmetros, se necessários
    });
}

// Instância Vue específica para RealtimeApp
if (document.getElementById('realtime-root')) {
    new Vue({
        el: '#realtime-root',
        store, // Se necessário compartilhar o store
        render: h => h(require('./components/realtime/RealtimeApp').default),
    });
}

// Instância Vue específica para Módulo de formulário do realtime
if (document.getElementById('solicitation-form-module')) {
    new Vue({
        el: '#solicitation-form-module',
        store,
        render: h => h(require('./components/solicitation/forms/SolicitationFormModule').default),
    });
}

if (document.getElementById('dashboard-app')) {
    new Vue({
        el: '#dashboard-app',
        store,
        render: h => h(require('./modules/dashboard/Dashboard.vue').default),
    });
}
